import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import './css/AddEliteMineModal.css';

const EliteMineModal = ({ isOpen, onRequestClose, onAddEliteMine }) => {
  const [level, setLevel] = useState(5);

  useEffect(() => {
    if (isOpen) {
      setLevel(5);
    }
  }, [isOpen]);

  const handleAddClick = () => {
    const parsedLevel = Number.parseInt(level, 10);
    if (!Number.isFinite(parsedLevel) || parsedLevel < 1 || parsedLevel > 5) {
      return;
    }
    onAddEliteMine(parsedLevel);
    onRequestClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="add-elite-mine-modal"
      overlayClassName="add-elite-mine-modal-overlay"
    >
      <h2>Add Elite Mine</h2>
      <p className="add-elite-mine-subtext">Select mine level (valid levels: 1 to 5).</p>
      <div className="add-elite-mine-level-grid">
        {[1, 2, 3, 4, 5].map((levelOption) => (
          <button
            key={levelOption}
            type="button"
            className={`add-elite-mine-level-button ${Number(level) === levelOption ? 'active' : ''}`}
            onClick={() => setLevel(levelOption)}
          >
            Level {levelOption}
          </button>
        ))}
      </div>
      <div className="add-elite-mine-actions">
        <button type="button" onClick={handleAddClick}>Add Elite Mine</button>
        <button type="button" onClick={onRequestClose}>Cancel</button>
      </div>
    </Modal>
  );
};

export default EliteMineModal;
